// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-08159758]{display:none}.pros-and-cons[data-v-08159758]{display:grid;grid-template-columns:1fr;grid-gap:24px;gap:24px}@media(min-width:768px){.pros-and-cons[data-v-08159758]{grid-template-columns:1fr 1fr;grid-gap:64px;gap:64px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
